import { el } from '../core/dom.js';
import { api } from '../core/api.js';
import { toast } from './toast.js';
import { syncOutcome, syncSourcePath } from '../core/parity.js';

/**
 * Admin "Sync now" for one CDL source. Cooldown and in-progress replies toast;
 * the password-style secret never applies here — the body is empty.
 * @param {string} sourceId
 * @param {string} [className]
 */
export function syncNowButton(sourceId, className) {
  const button = el('button', {
    type: 'button',
    class: className || 'dash-pill',
    onClick: () => runSync(button, sourceId),
  }, 'Sync now');
  return button;
}

async function runSync(button, sourceId) {
  if (!sourceId || button.disabled) return;
  button.disabled = true;
  button.textContent = 'Syncing…';
  const result = await api(syncSourcePath(sourceId), { method: 'POST', body: {} });
  const outcome = syncOutcome(result);
  toast(outcome.message, outcome.tone === 'error' ? 'error' : undefined);
  button.disabled = false;
  button.textContent = 'Sync now';
}
